import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../locale";
import confimeaModel from "../../images/confimea-model.pdf";

const ConfimeaConfirmationDocuments = ({
  documentUrl,
  loadingDocument,
  isAssociationMode = false,
  onDownload,
  onMissingDocument,
}) => {
  const handleDownload = () => {
    if (documentUrl) {
      window.open(documentUrl, "_blank", "noopener,noreferrer");
    } else if (isAssociationMode) {
      onMissingDocument?.();
      return;
    } else {
      const link = document.createElement("a");
      link.href = confimeaModel;
      link.download = "confimea-model.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (onDownload) {
      onDownload();
    }
  };

  return (
    <div className="confimea-confirmation-documents">
      <div className="confimea-confirmation-documents-header">
        <i className="pi pi-file"></i>
        <h3>{localeText("requiredDocuments")}</h3>
      </div>
      <div className="mb-2" style={{ color: "rgba(80, 80, 80, 1)" }}>
        {localeText("document1")}
      </div>
      <div className="mb-4 text-sm" style={{ color: "rgba(131, 162, 147, 1)" }}>
        {localeText("document2")}
      </div>
      <Button
        className="confimea-btn-download mb-3"
        label={
          <span className="text-sm">
            <i
              className={`pi ${loadingDocument ? "pi-spin pi-spinner" : "pi-download"} mr-2 text-lg`}
            />{" "}
            {localeText("downloadTemplateDocument")}
          </span>
        }
        onClick={handleDownload}
        outlined
        disabled={loadingDocument}
      />
      <div className="text-sm" style={{ color: "rgba(126, 145, 135, 1)" }}>
        {localeText("document3")}
      </div>
    </div>
  );
};

export default ConfimeaConfirmationDocuments;
